import { render, staticRenderFns } from "./PromptBar.vue?vue&type=template&id=6bd9f5bb&scoped=true&"
import script from "./PromptBar.vue?vue&type=script&lang=js&"
export * from "./PromptBar.vue?vue&type=script&lang=js&"
import style0 from "./PromptBar.vue?vue&type=style&index=0&id=6bd9f5bb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd9f5bb",
  null
  
)

export default component.exports